import React from "react";
import ReactDOM from "react-dom/client";

// Suppress ResizeObserver loop error (benign Radix UI warning)
const resizeObserverError = window.console.error;
window.console.error = (...args) => {
    if (args[0]?.includes?.('ResizeObserver') || String(args[0])?.includes?.('ResizeObserver')) {
        return;
    }
    resizeObserverError.apply(window.console, args);
};
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
